export interface MetadataDefinition {
  isRequired: boolean;
  isSearchCriteria: boolean;
  isResultCriteria: boolean;
  isIdentifier: boolean;
  metadataId: number;
  metadataLabel: string;
  metadataSystemName: string;
  metadataType: string;
  metadataMask: string;
  metadataMaskPlaceHolder: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadataMaskOption: any;
  position: number;
  enabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  optionValues: any[];
  asName: boolean;
  isExternalUpdated: boolean;
  isUnique: boolean;
  isMultivalue: boolean;
  isUpdateable: boolean;
}

export interface Metadata {
  value: string;
  systemName: string;
  name: string;
  description: string;
}

export interface MetadataFind {
  MetadataSearchTypeFrom: string;
  MetadataSearchTypeTo: string;
  MetadataSystemName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  MetadataValueFrom: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  MetadataValueTo: any;
  Nullvalue: boolean;
  metadataIsMultivalue: boolean;
}

export interface AddMetadataItem {
  metadataId?: number;
  key: string;
  description: string;
  currentOuId: number;
}

export enum MetadataClass {
  FIXED = 0,
  ADDITIONAL = 1
}